import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { ASSET_CLASSES } from '@fortem-monorepo/constants';
import { AXE_FLAGS } from '@fortem-monorepo/constants';
import { FACTORS } from '@fortem-monorepo/constants';
import { INDEX_TYPES } from '@fortem-monorepo/constants';
import { SUB_FACTORS } from '@fortem-monorepo/constants';
import { baseInstrumentSchema } from './shared/base.schema';
export const indexSchema = baseInstrumentSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Index),
    isin: z.string().length(12, 'Must be exactly 12 characters long.').optional().nullable(),
    index_type: z.enum(INDEX_TYPES),
    asset_class: z.enum(ASSET_CLASSES).nullable(),
    factor: z.enum(FACTORS).nullable(),
    sub_factor: z.enum(SUB_FACTORS).nullable(),
    axe_flag: z.enum(AXE_FLAGS).nullable(),
    bbg_ticker: z.string().min(1),
    issuer: z.string().nullable(),
    currency_id: z.number().int().positive(),
    country_id: z.number().int().positive(),
    description: z.string().min(1),
});
